import { render } from "./StartGameBoxId.vue?vue&type=template&id=949c68e8"
import script from "./StartGameBoxId.vue?vue&type=script&lang=js"
export * from "./StartGameBoxId.vue?vue&type=script&lang=js"

import "./StartGameBoxId.vue?vue&type=style&index=0&id=949c68e8&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__